export default __webpack_public_path__ + "static/media/beca.451d13f1.jpeg";